export const buildRootPatternSource = (rootNames) => {
  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return rootNames.map(escapeRegExp).join('|');
};

export const getPromptParameterPattern = (rootPatternSource) => {
  return new RegExp(
      `\\{\\{\\s*(((${rootPatternSource}))[A-Za-z0-9_-]*)(?=\\s*(?:\\.|\\}\\}))`,
      'gi',
  );
};

export const getRecognizedInterpolationRanges = (value, rootPatternSource) => {
  const ranges = [];
  let cursor = 0;

  while (cursor < value.length) {
    const openIndex = value.indexOf('{{', cursor);

    if (openIndex === -1) {
      break;
    }

    const closeIndex = value.indexOf('}}', openIndex + 2);

    if (closeIndex === -1) {
      break;
    }

    const tokenText = value.slice(openIndex, closeIndex + 2);
    const promptParameterPattern = getPromptParameterPattern(rootPatternSource);

    if (Array.from(tokenText.matchAll(promptParameterPattern)).length > 0) {
      ranges.push({
        start: openIndex,
        end: closeIndex + 2,
      });
    }

    cursor = closeIndex + 2;
  }

  return ranges;
};

export const getPromptSegments = (value, ranges) => {
  const segments = [];
  let cursor = 0;

  ranges.forEach((range, index) => {
    if (range.start > cursor) {
      segments.push({
        key: `plain-${index}-${cursor}`,
        text: value.slice(cursor, range.start),
        highlighted: false,
      });
    }

    segments.push({
      key: `highlight-${index}-${range.start}`,
      text: value.slice(range.start, range.end),
      highlighted: true,
    });

    cursor = range.end;
  });

  if (cursor < value.length) {
    segments.push({
      key: `plain-tail-${cursor}`,
      text: value.slice(cursor),
      highlighted: false,
    });
  }

  return segments;
};
